import * as iconLibrary from './library';

export const uiIcons = {
    chevronDown: iconLibrary.mdiChevronDown,
    chevronUp: iconLibrary.mdiChevronUp,
    lock: iconLibrary.mdiLockOutline,
    minus: iconLibrary.mdiMinus,
    no: iconLibrary.mdiClose,
    plus: iconLibrary.mdiPlus,
    question: iconLibrary.mdiQuestionMark,
    random: iconLibrary.gameDiceRandom,
    selectAll: iconLibrary.fluentSelectAllOn,
    selectNone: iconLibrary.fluentSelectAllOff,
    starEmpty: iconLibrary.mdiStarOutline,
    starHalf: iconLibrary.mdiStarHalfFull,
    starFull: iconLibrary.mdiStarFace,
    time: iconLibrary.mdiHourglass,
    yes: iconLibrary.mdiCheck,

    circleD: iconLibrary.mynauiLetterDCircle,
    circleF: iconLibrary.mynauiLetterFCircle,
    circleI: iconLibrary.mynauiLetterICircle,
    circleM: iconLibrary.mynauiLetterMCircle,
    circleP: iconLibrary.mynauiLetterPCircle,
    circleR: iconLibrary.mynauiLetterRCircle,
    circleS: iconLibrary.mynauiLetterSCircle,
    squareA: iconLibrary.mynauiLetterASquare,
    squareC: iconLibrary.mynauiLetterCSquare,
    squareD: iconLibrary.mynauiLetterDSquare,
    squareH: iconLibrary.mynauiLetterHSquare,
    squareL: iconLibrary.mynauiLetterLSquare,
    squareM: iconLibrary.mynauiLetterMSquare,
    squareN: iconLibrary.mynauiLetterNSquare,
    squareP: iconLibrary.mynauiLetterPSquare,
    squareW: iconLibrary.mynauiLetterWSquare,
};

export const aliasedIcons = {
    bookshelf: iconLibrary.mdiBookshelf,
    brick: iconLibrary.notoBrick,
    carrot: iconLibrary.notoCarrot,
    cloud: iconLibrary.notoCloud,
    devil: iconLibrary.mdiEmoticonDevilOutline,
    ice: iconLibrary.notoIce,
    island: iconLibrary.mdiIsland,
    pinkHeart: iconLibrary.notoPinkHeart,
    planet: iconLibrary.mdiPlanet,
    rose: iconLibrary.notoRose,
    snowflake: iconLibrary.notoSnowflake,
    stars: iconLibrary.gameStarsStack,
    swords: iconLibrary.gameCrossedSwords,
    sun: iconLibrary.notoSunWithFace,
    water: iconLibrary.notoWaterWave,
};
